module.exports = __webpack_public_path__ + "img/imagen10.3216c298.png";